//
//
//
//
//
//

import AQEmptyState from "@/components/Generics/AQEmptyState/AQEmptyState.vue";
import { exceptionsRoutes } from "./accessDeniedConst";

export default {
    name: "AccessDeniedPage",
    components: { AQEmptyState },
    props: {
        pageType: {
            type: String,
            default: ""
        }
    },
    computed: {
        getStateType() {
            const { path } = this.$route;
            return this.pageType || exceptionsRoutes[path] || "acessDenied";
        }
    },
    methods: {
        redirectToPage() {
            this.$router.push("/");
        }
    }
};
